import React from "react";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import styled from "styled-components";
import { IAmbienceMenuState } from "../IAmbienceMenuState";

export function AdjustAmbienceVolume({ volume }: { volume: number }) {
    return (
        <Container>
            <label htmlFor="customRange1" className="form-label">
                Ambience volume
            </label>
            <input
                type="range"
                className="form-range"
                min="0"
                max="1.0"
                step="0.1"
                value={volume}
                onChange={handleVolumeChange}
            />
        </Container>
    );
}

const handleVolumeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(event.target.value);

    const { currentAmbienceSoundFile } = State.ReadClass<IAmbienceMenuState>(
        ESharedComponent.AmbienceMenu
    ).state;

    currentAmbienceSoundFile?.volume(newVolume);

    State.ReadClass<IAmbienceMenuState>(ESharedComponent.AmbienceMenu).setState(
        {
            currentVolume: newVolume,
        }
    );
};

const Container = styled.div`
    opacity: 0.8;
`;
